import React from 'react'
import PropTypes from 'prop-types'
import { Container, Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import DashboardCard from '../../DashboardCard'

const ApplicationStatsSummary = ({ data, title }) => {
  if (!data || !data.application_stats) {
    return <div>Loading...</div>
  }

  const renderStatBlock = (label, value) => (
    <Grid container spacing={2} sx={{ paddingLeft: '2rem' }}>
      <Grid item md='auto' sm={12}>
        <Typography variant='body1' sx={{ fontWeight: 'bold', fontSize: '16' }}>
          {label}:
        </Typography>
      </Grid>
      <Grid item md='auto' sm={12}>
        <Typography variant='body1' sx={{ fontSize: '16' }}>
          {value}
        </Typography>
      </Grid>
    </Grid>
  )

  const {
    approved,
    reproved,
    created,
    finished,
    expired,
    dd_in_progress,
    waiting_review,
    processing_bgc,
  } = data.application_stats

  return (
    <DashboardCard title={title}>
      <Container maxWidth='xl' sx={{ width: '100%', margin: '0 auto', padding: '2rem' }}>
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Aplicações por status</h4>
          </Grid>

          {renderStatBlock('Criadas', created)}
          {renderStatBlock('Expiradas', expired)}
          {renderStatBlock('Finalizadas', finished)}
          {renderStatBlock('Aguardando análise', waiting_review)}
          {renderStatBlock('Due diligence em andamento', dd_in_progress)}
          {renderStatBlock('Processando background check', processing_bgc)}

          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Aplicações aprovadas</h4>
          </Grid>
          {renderStatBlock('Total', approved.total)}
          {renderStatBlock('Aprovação automática', approved.auto)}
          {renderStatBlock('Aprovação manual', approved.manual)}

          <Grid item md={12} sm={12} sx={{ marginBottom: '1rem' }}>
            <h4>Aplicações reprovadas</h4>
          </Grid>
          {renderStatBlock('Total', reproved.total)}
          {renderStatBlock('Reprovação automática', reproved.auto)}
          {renderStatBlock('Reprovação manual', reproved.manual)}
        </Grid>
      </Container>
    </DashboardCard>
  )
}

ApplicationStatsSummary.propTypes = {
  data: PropTypes.shape({
    application_stats: PropTypes.shape({
      approved: PropTypes.shape({
        total: PropTypes.number.isRequired,
        manual: PropTypes.number.isRequired,
        auto: PropTypes.number.isRequired,
      }).isRequired,
      reproved: PropTypes.shape({
        total: PropTypes.number.isRequired,
        manual: PropTypes.number.isRequired,
        auto: PropTypes.number.isRequired,
      }).isRequired,
      created: PropTypes.number.isRequired,
      finished: PropTypes.number.isRequired,
      expired: PropTypes.number.isRequired,
      waiting_review: PropTypes.number.isRequired,
      dd_in_progress: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
}

export default ApplicationStatsSummary
